import React from 'react';
import { motion } from 'framer-motion';
import { UserIcon, TimerIcon, RocketIcon, DollarSignIcon, ArrowRightIcon } from 'lucide-react';
const audiences = [{
  icon: UserIcon,
  title: 'Nunca vendiste digital',
  desc: 'Querés tu primera venta real sin gastar meses aprendiendo.'
}, {
  icon: TimerIcon,
  title: 'Emprendedores sin tiempo',
  desc: 'Querés un sistema directo, sin teoría de relleno.'
}, {
  icon: RocketIcon,
  title: 'Ya intentaste y no arrancaste',
  desc: 'Tenés el deseo pero te faltaba la estructura correcta.'
}, {
  icon: DollarSignIcon,
  title: 'Querés ingresos reales',
  desc: 'No buscás un hobbie, buscás dinero de verdad.'
}];
export function TargetAudience() {
  return <section className="py-12 md:py-20 bg-dark-800/30 border-y border-white/5" data-id="element-275">
      <div className="container mx-auto px-4" data-id="element-276">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-277">
          <h2 className="text-gold-500 font-display text-base md:text-2xl tracking-widest uppercase mb-2 md:mb-3" data-id="element-278">
            ¿Para quién es?
          </h2>
          <p className="text-xl md:text-4xl font-display text-white uppercase tracking-wide leading-tight" data-id="element-279">
            Diseñado para vos si querés arrancar de una vez
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 gap-3 md:gap-5 max-w-5xl mx-auto" data-id="element-280">
          {audiences.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} whileHover={{
          scale: 1.02
        }} className="flex md:flex-row flex-col gap-3 md:gap-5 bg-dark-900 p-4 md:p-6 rounded-xl border-gold-subtle items-start hover:border-gold-500/40 transition-colors" data-id="element-281">
              <div className="shrink-0 w-10 h-10 md:w-12 md:h-12 bg-gold-500/10 rounded-lg flex items-center justify-center border border-gold-500/20" data-id="element-282">
                <item.icon className="text-gold-500 w-5 h-5 md:w-6 md:h-6" data-id="element-283" />
              </div>
              <div data-id="element-284">
                <h3 className="text-sm md:text-lg font-bold text-white mb-1 leading-tight" data-id="element-285">
                  {item.title}
                </h3>
                <p className="text-gray-400 text-xs md:text-sm leading-snug" data-id="element-286">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 md:mt-12 text-center flex flex-col items-center justify-center gap-2" data-id="element-287">
          <p className="text-gray-400 text-sm" data-id="element-288">
            ¿No estás seguro si es para vos?
          </p>
          <div className="inline-flex items-center gap-2 text-gold-500 font-bold uppercase tracking-wider hover:text-gold-400 transition-colors cursor-pointer text-sm" data-id="element-289">
            Tenés 7 días de garantía <ArrowRightIcon size={16} data-id="element-290" />
          </div>
        </div>
      </div>
    </section>;
}